import styles from "./index.module.scss";

export default function PortfolioLoadingDots() {
  return (
    <span className={styles.portfolioLoadingDots} aria-hidden>
      <span />
      <span />
      <span />
    </span>
  );
}
